/*
 Created by qing on 2020/9/8
 Des:
 */
import BaseItem from "../BaseItem"
import {DATA_TYPE__STRING, FORM_ITEM__SIGNATURE} from "../types"

class Signature extends BaseItem {
  constructor() {
    super()

    // 填写内容
    this.value = ''

    this.configInfo = {} // 预留字段
  }

  get title() {
    return this.fieldTitle || Signature._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }

}

Signature._title = '手写签名'
Signature.type = FORM_ITEM__SIGNATURE
Signature.use = true
Signature.icon = 'iconfont icon-signature'
Signature.prototype.icon = 'iconfont icon-signature'

// 组件类型
Signature.prototype.type = Signature.type
// 数据类型
Signature.prototype.dataType = DATA_TYPE__STRING

Signature.prototype.getValue = function () {
  return this.value
}
Signature.prototype.setValue = function (val) {
  this.value = val || ''
}
Signature.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    configInfo: this.configInfo
  }
}
Signature.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.configInfo = opts.configInfo || {}
}
Signature.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}


export default Signature
